/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Filter Utility
 */

import { oforEach } from '@zcode/nr-utils'
import type { Filters } from '@zcode/state-type'
import deepequal from 'fast-deep-equal'
import DEFAULT_FILTERS from '../../shared/constants/default_filters'

/**
 * returns an array of boolean values for where selected bedroom is true ex: 1 to
 * [false, true, false, false..]
 *
 * @param bedroomCount
 */
export const bedroomCountToBoolArray = (bedroomCount: number | null | undefined) => {
  return [
    bedroomCount === 0,
    bedroomCount === 1,
    bedroomCount === 2,
    bedroomCount === 3,
    bedroomCount === 4,
    bedroomCount === 5,
  ] as const
}

/**
 * Gets bedroom filter for city and neighborhood pages if there's a single specified bedroom.
 *
 * @param filters
 */
export const getSingleBedroomFilterText = (filters: Pick<Filters, 'bedrooms'>) => {
  const { bedrooms } = filters
  // pop to ignore the 5 bedroom filter since we only care about 0-4
  if (bedrooms.slice(0, -1).filter((br) => br).length === 1) {
    const br = bedrooms.indexOf(true)
    if (br === 0) {
      return 'Studio' as const
    }
    return `${br} Bedroom` as const
  }
  return '' as const
}

/**
 * how many filters are set?
 *
 * @param filters
 */
export const getFilterCount = (filters: Filters) => {
  let count = 0
  oforEach(filters, (value, key) => {
    if (key === 'features') {
      count += filters.features?.length
    } else if (deepequal(value, DEFAULT_FILTERS[key])) {
      count += 1
    }
  })
  return count
}
